import { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { toRelativeUrl } from '@okta/okta-auth-js';

const AdminRoute = ({ children }) => {
   const { oktaAuth, authState } = useOktaAuth();

   useEffect(() => {
      if (!authState) {
         return;
      }

      if (!authState.isAuthenticated) {
         // Store the current URL to redirect back after login
         const originalUri = toRelativeUrl(
            window.location.href,
            window.location.origin,
         );
         oktaAuth.setOriginalUri(originalUri);
         // Trigger Okta authentication
         oktaAuth.signInWithRedirect();
      }
   }, [ oktaAuth, authState ]);

   // Show loading while authentication state is being determined
   if (!authState || !authState.isAuthenticated) {
      return null;
   }

   return children;
};

export default AdminRoute;
